var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { gpstoVec3 } from '../../utils/helpers';
export default function Location(_a) {
    var { coordinates, isCurrentLocation } = _a, props = __rest(_a, ["coordinates", "isCurrentLocation"]);
    const position = useMemo(() => {
        const radius = 1;
        const { lat, lng } = coordinates;
        return gpstoVec3(lat, lng, radius);
    }, [coordinates]);
    return (React.createElement("mesh", Object.assign({ scale: isCurrentLocation ? 0.03 : 0.015, position: position }, props),
        React.createElement("sphereGeometry", { args: [1, 8, 8] }),
        React.createElement("meshBasicMaterial", { color: isCurrentLocation ? '#00c2ff' : 'red' })));
}
